export var isNative = false;
export var isWeb = true;
export function platformSelect(options) {
  if ('web' in options) {
    return options.web;
  }
  if ('default' in options) {
    return options.default;
  }
  throw new Error('Unable to select platform');
}
//# sourceMappingURL=select.js.map